export const ContactType = {
    1: "Finance Manager",
    2: "Accounts Payable Contact",
    3: "Procurement Lead",
    4: "Legal Representative",
    5: "Project Manager",
    6: "Technical Lead",
    7: "Operations Manager",
    8: "Business Development Manager",
    9: "Customer Success Manager",
    10: "Commercial Manager",
    11: "Quantity Surveyor",
} as const;

export type ContactTypeId = keyof typeof ContactType; // Type representing valid role IDs


export const ProposalType = {
    1: "Proposal",
    2: "Early Warning",
    3: "Variation Lead",
    4: "Variation",
} as const;

export type ProposalTypeId = keyof typeof ProposalType; // Type representing valid role IDs


export enum FeeStageType {
    Framework = 1,
    Custom = 2,
}

export enum UserType {
    TechnicalProjectLead = 1,
    AssistantTechnicalProjectLead = 2
}

export const FeeStageStatus = {
    1: "Instructed",
    2: "Working On It",
    3: "Completed",
    4: "Not Required"
} as const;

export type FeeStageStatusId = keyof typeof FeeStageStatus;